import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Link, withRouter } from 'react-router-dom'
import ReactCountryFlag from 'react-country-flag'
import {
  Row,
  Col,
  Layout,
  Menu,
  Icon,
  Modal,
  Drawer,
  Button,
  Tooltip,
  Radio,
  Spin,
  message,
} from 'antd'
import NoticeIcon from 'ant-design-pro/lib/NoticeIcon'
import Notification from './Notification'
import PrioritySettingPage from './PrioritySettingPage'
import PasswordExpiryBanner from './PasswordExpiryBanner'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import { endSession, getRefreshToken, nowSeconds } from 'lib/webSession'
import { SESSION_EXPIRED_EVENT } from './WebSessionKeeper'
import * as authActions from 'modules/auth/actions'
import {
  clearFlashMessage,
  loadNotificationCount,
  removeUIState,
} from 'modules/ui/actions'
import SliderBarNewNode from './SliderBarNewNode'
import styled from 'styled-components'
import { checkPermissions } from 'lib/helper'
import { max } from 'date-fns'

//////////////////////////////////////////////////////////////
const SubMenu = Menu.SubMenu
const MenuItemGroup = Menu.ItemGroup
const { Header: H } = Layout
const StyledHearder = styled(H)`
  background: white;
  padding: 0px 0px px 0px;
  height: 45px;
`

/** localStorage profile, or {} when missing / unreadable. */
export function readStoredProfile(storage = localStorage) {
  try {
    const profile = JSON.parse(storage.getItem('profile') || '{}')
    return profile && typeof profile === 'object' ? profile : {}
  } catch (e) {
    return {}
  }
}

class Header extends Component {
  state = {
    collapsed: true,
    notiCount: 0,
    haveNewNoti: false,
    inputLng: '',
    autoOrderModeVisible: false,
    autoOrderMode: 'normal',
    autoOrderModeLoading: false,
    autoOrderModeFetching: false,
    auto_order_pre_order: 0,
    priorityModalVisible: false,
  }

  _isMounted = false

  logoutAzure = () => {
    window.location.href =
      'https://login.microsoftonline.com/5db8bf0e-8592-4ed0-82b2-a6d4d77933d4/oauth2/logout?post_logout_redirect_uri=' +
      process.env.REACT_APP_REDIRECT_URI
  }
  logoutJ2C = () => {
    window.location.href =
      'https://api-cpac.scg.com/auth/logout?redirect=' +
      process.env.REACT_APP_REDIRECT_URI
  }
  logoutCpac = () => {
    let userAuthen = localStorage.getItem('userAuthen')
    switch (userAuthen) {
      case 'Azure':
        this.logoutAzure()
        break
      case 'J2C':
        this.logoutJ2C()
        break
      default:
    }
  }

  onRemoveCredentials = () => {
    if (typeof this.props.profile !== 'undefined') {
      this.updateUserHistoryLog()
    }
    this.logoutCpac()
    endSession()
    this.props.removeCredentials()
    this.props.removeUIState()
  }

  updateUserHistoryLog = () => {
    axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/updatelogonhistory`,
        {
          id: this.props.profile.user_history_logon_id,
        },
        {
          headers: { Authorization: `Bearer ${this.props.accessToken}` },
        },
      )
      .then((res) => {})
  }

  onDismiss = () => {
    this.props.clearFlashMessage()
  }

  onItemClick = (item, tabProps) => {
    // history.push(item.path);
    //window.location.href = item.path;
  }

  onClear = (tabTitle) => {
    // console.log(tabTitle)
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  getNoticeData = (langContext, notices) => {
    if (notices.length === 0) {
      return []
    }
    const newNotices = notices.map((notice) => {
      let newNotice = {
        ...notice,
        datetime: null,
        title: (
          <Link to={notice.path}>
            {
              langContext[notice.matching_name.charAt(0).toLowerCase()][
                notice.matching_name
              ]
            }
          </Link>
        ),
        avatar:
          'https://gw.alipayobjects.com/zos/rmsportal/GvqBnKhFgObvnSGkDsje.png',
        extra: (
          <Button
            style={{ marginTop: '0px' }}
            size='small'
            icon='delete'
            onClick={() =>
              this.props.deleteFavoriteMenu(
                {
                  userId: this.props.profile.id,
                  favId: newNotice.id,
                  accessToken: this.props.accessToken,
                },
                () => false,
              )
            }
          />
        ),
      }

      // transform id to item key
      if (newNotice.id) {
        newNotice.key = newNotice.id
      }

      return newNotice
    })

    return newNotices
  }

  showTokenExpired = () => {
    this.modal(
      <LangContext.Consumer>
        {(i18n) => i18n.n.notification}
      </LangContext.Consumer>,
      <LangContext.Consumer>
        {(i18n) => i18n.t.tokenExpired}
      </LangContext.Consumer>,
    )
  }

  // sessions with a refresh token are kept alive by WebSessionKeeper (Layout);
  // Header only keeps the old popup at expiry for sessions without one
  scheduleTokenCheck = () => {
    clearTimeout(this.tokenExpTimeout)
    const { tokenExp } = this.props
    const now = nowSeconds()

    if (typeof tokenExp == 'undefined' || tokenExp == null || tokenExp == '') {
      this.tokenExpTimeout = setTimeout(this.showTokenExpired, 500)
    } else if (getRefreshToken()) {
      return
    } else if (now < tokenExp) {
      this.tokenExpTimeout = setTimeout(this.showTokenExpired, (tokenExp - now) * 1000)
    }
  }

  // WebSessionKeeper could not refresh: show the usual popup + full logout here
  handleSessionExpired = (e) => {
    e.preventDefault()
    this.showTokenExpired()
  }

  componentDidMount() {
    this._isMounted = true

    this.scheduleTokenCheck()
    window.addEventListener(SESSION_EXPIRED_EVENT, this.handleSessionExpired)

    if (typeof this.props.profile.id != 'undefined')
      this.props.loadFavoriteMenu({
        userId: this.props.profile.id,
        accessToken: this.props.accessToken,
        loading: false,
      })

    this.setState({
      inputLng: 'th',
    })

    this.fetchAutoOrderMode()
  }

  fetchAutoOrderMode = () => {
    if (
      typeof this.props.profile === 'undefined' ||
      !this.props.profile.company_id
    )
      return
    this.setState({ autoOrderModeFetching: true })
    axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/companies/get-auto-order-settings`,
        { company_id: this.props.profile.company_id },
        {
          headers: { Authorization: `Bearer ${this.props.accessToken}` },
        },
      )
      .then((res) => {
        if (this._isMounted && res.data && res.data.auto_order_mode) {
          this.setState({
            autoOrderMode: res.data.auto_order_mode,
            auto_order_pre_order: res.data.auto_order_pre_order || 0,
            autoOrderModeFetching: false,
          })
        }
      })
      .catch(() => {
        if (this._isMounted) {
          this.setState({ autoOrderModeFetching: false })
        }
      })
  }

  handleAutoOrderModeOpen = () => {
    this.setState({ autoOrderModeVisible: true })
    this.fetchAutoOrderMode()
  }

  handleAutoOrderModeClose = () => {
    this.setState({
      autoOrderModeVisible: false,
      autoOrderMode: 'normal',
      autoOrderModeFetching: false,
      auto_order_pre_order: 0,
    })
  }

  handleAutoOrderModeConfirm = () => {
    Modal.confirm({
      title: 'ยืนยันการเปลี่ยน Auto Order Setting',
      content: `เปลี่ยนเป็นโหมด "${
        this.state.autoOrderMode === 'normal' ? 'Normal' : 'Priority'
      }" และ Pre-order "${
        this.state.auto_order_pre_order === 1 ? 'เปิด' : 'ปิด'
      }" ใช่หรือไม่?`,
      okText: 'ยืนยัน',
      cancelText: 'ยกเลิก',
      onOk: () => {
        this.setState({ autoOrderModeLoading: true })
        axios
          .post(
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/companies/update-auto-order-settings`,
            {
              company_id: this.props.profile.company_id,
              auto_order_mode: this.state.autoOrderMode,
              auto_order_pre_order: this.state.auto_order_pre_order,
              is_admin: this.props.profile.is_admin,
            },
            {
              headers: { Authorization: `Bearer ${this.props.accessToken}` },
            },
          )
          .then((res) => {
            if (this._isMounted) {
              this.setState({
                autoOrderModeLoading: false,
                autoOrderModeVisible: false,
              })
              message.success('อัพเดท Auto Order Setting สำเร็จ')
            }
          })
          .catch(() => {
            if (this._isMounted) {
              this.setState({ autoOrderModeLoading: false })
              message.error('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
            }
          })
      },
    })
  }

  handlePriorityModalOpen = () => {
    this.setState({ priorityModalVisible: true })
  }

  handlePriorityModalClose = () => {
    this.setState({ priorityModalVisible: false })
  }

  componentWillUnmount() {
    this._isMounted = false
    clearTimeout(this.tokenExpTimeout)
    window.removeEventListener(SESSION_EXPIRED_EVENT, this.handleSessionExpired)
  }

  checkSelectLang = (inputLng) => {
    this.props.changeLang(inputLng)
    if (inputLng == 'en') {
      this.setState({
        inputLng: 'us',
      })
    } else {
      this.setState({
        inputLng: 'th',
      })
    }
  }

  modal = (title, content) => {
    this.onRemoveCredentials()
    Modal.warning({
      title: title,
      okText: 'Ok',
      okType: 'default',
      onOk() {
        // window.location.href = "/";
      },
      content: content,
    })
  }

  render() {
    localStorage.length == 1 && window.location.reload()
    const { done, flash } = this.props

    const CheLan = (
      <LangContext.Consumer>
        {(i18n) => i18n.changeLanguage}
      </LangContext.Consumer>
    )

    // profile can already be gone while this tab leaves for the account-locked
    // view (lib/webSession goToAccountLockedPage · DECISIONS #27) — never throw here
    const storedProfile = readStoredProfile()
    let firstName = storedProfile.firstname ? storedProfile.firstname : ''
    let lastName = storedProfile.lastname ? storedProfile.lastname : ''
    return (
      <Fragment>
        <StyledHearder>
          <audio id='audio-alert'>
            <source src='/audio/alert/serious-strike.mp3' type='audio/mpeg' />
          </audio>
          <audio id='audio-sos'>
            <source src='/audio/alert/sos.mp3' type='audio/mpeg' />
          </audio>
          <audio id='audio-notification'>
            <source
              src='/audio/notification/slow-spring-board.mp3'
              type='audio/mpeg'
            />
          </audio>

          <Row
            type='flex'
            justify='space-between'
            align='middle'
            style={{
              lineHeight: '20px',
              padding: '0px 0px 0px 0px',
              margin: '0px 0px 0px 0px',
              borderBottom: '4px solid red',
            }}
          >
            <Col xs={{ span: 0 }} sm={3} md={1} lg={1} xl={1}>
              <Icon
                style={{
                  margin: '3px 0px 0px 15px',
                  color: '#ff0b0b',
                  fontSize: '24px',
                }}
                className='trigger'
                type='menu'
                onClick={this.toggle}
              />

              {/* <i
                                className="fas fa-bars"
                                style={{
                                    margin: '3px 0px 0px 15px',
                                    color: '#ff0b0b',
                                    fontSize: '24px',
                                }} className="trigger"
                                type="menu"
                                onClick={this.toggle}
                            >
                            </i> */}
            </Col>
            {process.env.REACT_APP_WEB_ENDPOINT == 'isupply' ? (
              <Col xs={8} sm={1} md={1} lg={1} xl={1}>
                <Link to={`/`}>
                  <img
                    style={{ width: '42px' }}
                    src='/img/isupply.png'
                    alt=''
                  />
                </Link>
              </Col>
            ) : (
              <Col xs={8} sm={5} md={4} lg={4} xl={4}>
                <Link to={`/`}>
                  <img style={{ width: '85px' }} src='/img/2.png' alt='' />
                </Link>
              </Col>
            )}
            {process.env.REACT_APP_WEB_ENDPOINT == 'isupply' ? (
              <Col xs={8} sm={3} md={3} lg={3} xl={3} align='left'>
                <p
                  style={{
                    marginBottom: '0px',
                    color: '#379aec',
                    fontSize: '25px',
                    fontWeight: 500,
                  }}
                >
                  iSupply
                </p>
              </Col>
            ) : (
              ''
            )}
            <Col sm={16} md={19} lg={19} xl={19} align='right'>
              <Menu
                theme='light'
                mode='horizontal'
                style={{
                  height: '46px',
                }}
                align='right'
              >
                {checkPermissions(
                  this.props.profile.permissions || [],
                  'autoOrderPriority',
                  'can_view',
                ) && (
                  <SubMenu
                    className='ant-top-menu '
                    title={
                      <LangContext.Consumer>
                        {(i18n) => (
                          <Tooltip
                            placement='bottom'
                            title='Auto Order Setting'
                            arrowPointAtCenter
                          >
                            <Icon
                              style={{
                                fontSize: '17px',
                                color:
                                  this.state.autoOrderMode === 'priority'
                                    ? '#ff0b0b'
                                    : undefined,
                              }}
                              type='setting'
                              onClick={this.handleAutoOrderModeOpen}
                            />
                          </Tooltip>
                        )}
                      </LangContext.Consumer>
                    }
                  ></SubMenu>
                )}
                {checkPermissions(
                  this.props.profile.permissions || [],
                  'commandCenterDashboard',
                  'can_view',
                ) && (
                  <SubMenu
                    className='ant-top-menu '
                    title={
                      <LangContext.Consumer>
                        {(i18n) => (
                          <Tooltip
                            placement='bottom'
                            title='Command Center Dashboard'
                            arrowPointAtCenter
                          >
                            <Icon
                              style={{ fontSize: '17px' }}
                              type='project'
                              onClick={() => {
                                window.open(
                                  '/command-center-dashboard',
                                  '_blank',
                                )
                              }}
                            />
                          </Tooltip>
                        )}
                      </LangContext.Consumer>
                    }
                  ></SubMenu>
                )}
                <SubMenu
                  className='ant-top-menu '
                  title={
                    // <span>
                    <LangContext.Consumer>
                      {(i18n) => (
                        <Tooltip
                          placement='bottom'
                          title={`RMC Operation Dashboard`}
                          arrowPointAtCenter
                        >
                          <Icon
                            style={{ fontSize: '17px' }}
                            type='area-chart'
                            onClick={() => {
                              window.open(
                                'https://dev-rop.cipcloud.net/home',
                                '_blank',
                              )
                            }}
                          />
                        </Tooltip>
                      )}
                    </LangContext.Consumer>
                    // </span>
                  }
                ></SubMenu>
                <SubMenu
                  className='ant-top-menu '
                  title={
                    // <span>
                    <LangContext.Consumer>
                      {(i18n) => (
                        <Tooltip
                          placement='bottom'
                          title={i18n.m.manual}
                          arrowPointAtCenter
                        >
                          <Icon
                            style={{ fontSize: '17px' }}
                            type='read'
                            onClick={() => {
                              window.open(
                                'https://scgo365.sharepoint.com/sites/rmcexcellence/isupplymanual/SitePages/Home.aspx?csf=1&web=1&e=v1KKeG&CID=bc3c2ea1-0ae2-43f5-a6c7-5bbecd0b9c7b',
                                '_blank',
                              )
                            }}
                          />
                        </Tooltip>
                      )}
                    </LangContext.Consumer>
                    // </span>
                  }
                ></SubMenu>
                <SubMenu
                  className='ant-top-menu '
                  title={
                    <span>
                      <LangContext.Consumer>
                        {(i18n) => (
                          <NoticeIcon
                            // onItemClick={this.onItemClick}
                            onItemClick={(e) => e}
                            onClear={this.onClear}
                            bell={
                              <Icon
                                type='star'
                                style={{ color: '#ff0b0b', fontSize: '17px' }}
                              />
                            }
                          >
                            <NoticeIcon.Tab
                              showClear={false}
                              list={this.getNoticeData(
                                i18n,
                                this.props.favoriteMenu,
                              )}
                              title={i18n.f.favoriteMenu}
                              emptyText={i18n.n.noData}
                              emptyImage='https://gw.alipayobjects.com/zos/rmsportal/wAhyIChODzsoKIOBHcBk.svg'
                            />
                          </NoticeIcon>
                        )}
                      </LangContext.Consumer>
                    </span>
                  }
                ></SubMenu>

                <SubMenu
                  className='ant-top-menu '
                  title={
                    <span>
                      <ReactCountryFlag
                        styleProps={{
                          margin: '0px 15px 5px 0px',
                          width: '20px',
                          height: '20px',
                        }}
                        code={this.state.inputLng}
                        svg
                      />
                      <Icon type='caret-down' style={{ color: '#ff0b0b' }} />
                    </span>
                  }
                >
                  <MenuItemGroup title={CheLan}>
                    <Menu.Item key='en' selected={true}>
                      <span
                        className='nav-text'
                        onClick={() => this.checkSelectLang('en')}
                      >
                        <ReactCountryFlag
                          styleProps={{
                            margin: '0px 15px 5px 0px',
                            width: '20px',
                            height: '20px',
                          }}
                          code='us'
                          svg
                        />
                        English
                      </span>
                    </Menu.Item>
                    <Menu.Item key='th' selected={true}>
                      <span
                        className='nav-text'
                        onClick={() => this.checkSelectLang('th')}
                      >
                        <ReactCountryFlag
                          styleProps={{
                            margin: '0px 15px 5px 0px',
                            width: '20px',
                            height: '20px',
                          }}
                          code='th'
                          svg
                        />
                        ไทย
                      </span>
                    </Menu.Item>
                  </MenuItemGroup>
                </SubMenu>
                <SubMenu
                  style={{ width: '220px' }}
                  className='ant-top-menu '
                  title={
                    <div>
                      <Row style={{ height: '46px' }}>
                        <Col xs={1} sm={1} md={1} lg={2} xl={2}>
                          <Icon
                            type='user'
                            style={{
                              //   margin: "-15px 5px 0px 0px",
                              fontSize: '16px',
                              color: '#ff0b0b',
                            }}
                          />
                        </Col>
                        <Col
                          xs={0}
                          sm={0}
                          md={23}
                          lg={20}
                          xl={20}
                          style={{ height: '46px' }}
                        >
                          <Tooltip
                            placement='bottom'
                            title={firstName + ' ' + lastName}
                            arrowPointAtCenter
                          >
                            <Row
                              style={{
                                margin: '-11px 0px 0px 20px',
                                color: '#ff0b0b',
                                // marginTop: "-40px",
                              }}
                            >
                              {JSON.parse(localStorage.getItem('profile'))
                                .username.length > 20
                                ? JSON.parse(
                                    localStorage.getItem('profile'),
                                  ).username.substr(0, 19) + '...'
                                : JSON.parse(localStorage.getItem('profile'))
                                    .username}
                            </Row>
                            <Row
                              style={{
                                margin: '-27px 0px 0px 20px',
                                color: '#ff0b0b',
                                // marginTop: "-40px",
                              }}
                            >
                              {(firstName + ' ' + lastName).length > 20
                                ? (firstName + ' ' + lastName).substr(0, 19) +
                                  '...'
                                : firstName + ' ' + lastName}
                            </Row>
                          </Tooltip>
                        </Col>
                      </Row>
                    </div>
                  }
                >
                  <MenuItemGroup
                    title={<span className='semi-bold-16'>Account</span>}
                    style={{}}
                  >
                    <Menu.Item key='setting:1' style={{ paddingLeft: '14px' }}>
                      <Icon type='home' style={{ color: 'black' }} />
                      <span style={{ fontSize: '14px', color: 'black' }}>
                        <LangContext.Consumer>
                          {(i18n) => i18n.h.home}
                        </LangContext.Consumer>
                      </span>
                      <Link to='/' />
                    </Menu.Item>
                    <Menu.Item key='setting:2' style={{ paddingLeft: '14px' }}>
                      <Icon type='user' style={{ color: 'black' }} />
                      <span style={{ fontSize: '14px', color: 'black' }}>
                        <LangContext.Consumer>
                          {(i18n) => i18n.p.profile}
                        </LangContext.Consumer>
                      </span>

                      <Link to='/profile' />
                    </Menu.Item>
                    {done ? (
                      <Menu.Item
                        key='menu:1'
                        onClick={this.onRemoveCredentials}
                        style={{ paddingLeft: '14px' }}
                      >
                        <Icon type='logout' style={{ color: 'black' }} />
                        <span style={{ fontSize: '14px', color: 'black' }}>
                          <LangContext.Consumer>
                            {(i18n) => i18n.l.logout}
                          </LangContext.Consumer>
                        </span>

                        <Link to='/' />
                      </Menu.Item>
                    ) : (
                      <Menu.Item key='menu:1' style={{ paddingLeft: '14px' }}>
                        <span style={{ fontSize: '14px' }}>
                          <LangContext.Consumer>
                            {(i18n) => i18n.l.login}
                          </LangContext.Consumer>
                        </span>

                        <Link to='/' />
                      </Menu.Item>
                    )}
                  </MenuItemGroup>
                  {/* <MenuItemGroup title="Setting">
                    <Menu.Item key="setting:3">Option 3</Menu.Item>
                    <Menu.Item key="setting:4">Option 4</Menu.Item>
                  </MenuItemGroup> */}
                </SubMenu>
              </Menu>
            </Col>
          </Row>
        </StyledHearder>
        <PasswordExpiryBanner accessToken={this.props.accessToken} />
        <Row type='flex' justify='end' style={{ margin: '0px' }} />
        {flash && (
          <Row type='flex' justify='center' style={{ margin: '0px' }}>
            {/* <Col span={24}>
              <Alert
                message={flash.message}
                type={flash.type}
                closable
                afterClose={this.handleClose}
              />
            </Col> */}
          </Row>
        )}

        <Drawer
          title={<h3 className='text-header-side-bar'>MENU</h3>}
          placement='left'
          // closable={false}
          onClose={this.toggle}
          visible={!this.state.collapsed}
          //   getContainer={false}
          style={{ position: 'absolute' }}
          // headerStyle={{ padding: '7px 10px', borderBottom: '1.6px solid red' }}
          bodyStyle={{ padding: '0px', border: '0px' }}
          width={352}
          height={max}
          // maskClosable={false}
          // mask={false}
        >
          <SliderBarNewNode drawerVisible={!this.state.collapsed} />
          {/* <SliderBarV2 /> */}
        </Drawer>

        <Modal
          title='Auto Order Setting'
          visible={this.state.autoOrderModeVisible}
          onCancel={this.handleAutoOrderModeClose}
          footer={
            checkPermissions(
              this.props.profile.permissions || [],
              'autoOrderPriority',
              'can_edit',
            )
              ? [
                  <Button key='cancel' onClick={this.handleAutoOrderModeClose}>
                    ยกเลิก
                  </Button>,
                  <Button
                    key='confirm'
                    type='primary'
                    loading={this.state.autoOrderModeLoading}
                    onClick={this.handleAutoOrderModeConfirm}
                  >
                    ยืนยัน
                  </Button>,
                ]
              : [
                  <Button key='cancel' onClick={this.handleAutoOrderModeClose}>
                    ปิด
                  </Button>,
                ]
          }
        >
          <Spin
            spinning={
              this.state.autoOrderModeFetching ||
              this.state.autoOrderModeLoading
            }
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <span
                style={{ fontWeight: 'bold', width: '160px', flexShrink: 0 }}
              >
                Auto Order Mode:
              </span>
              <Radio.Group
                value={this.state.autoOrderMode}
                onChange={(e) =>
                  this.setState({ autoOrderMode: e.target.value })
                }
                disabled={
                  !checkPermissions(
                    this.props.profile.permissions || [],
                    'autoOrderPriority',
                    'can_edit',
                  )
                }
              >
                <Radio.Button value='normal'>Normal</Radio.Button>
                <Radio.Button value='priority'>Priority</Radio.Button>
              </Radio.Group>
              <Tooltip title='ตั้งค่า Priority ของแต่ละโรงงาน'>
                <Button
                  type='default'
                  size='small'
                  shape='circle'
                  icon='setting'
                  style={{ marginLeft: '12px' }}
                  onClick={this.handlePriorityModalOpen}
                />
              </Tooltip>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <span
                style={{ fontWeight: 'bold', width: '160px', flexShrink: 0 }}
              >
                Pre-order:
              </span>
              <Radio.Group
                value={this.state.auto_order_pre_order}
                onChange={(e) =>
                  this.setState({ auto_order_pre_order: e.target.value })
                }
                disabled={
                  !checkPermissions(
                    this.props.profile.permissions || [],
                    'autoOrderPriority',
                    'can_edit',
                  )
                }
              >
                <Radio.Button value={1}>เปิด</Radio.Button>
                <Radio.Button value={0}>ปิด</Radio.Button>
              </Radio.Group>
            </div>
          </Spin>
        </Modal>
        <PrioritySettingPage
          visible={this.state.priorityModalVisible}
          onClose={this.handlePriorityModalClose}
          accessToken={this.props.accessToken}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = ({
  auth: { accessToken, done, profile, tokenExp, favoriteMenu },
  ui: { flash, lastestNotificationAt },
}) => ({
  accessToken,
  done,
  profile,
  flash,
  lastestNotificationAt,
  tokenExp,
  favoriteMenu,
})
const mapDispatchToProps = {
  loadFavoriteMenu: authActions.loadFavoriteMenu.request,
  removeCredentials: authActions.removeCredentials,
  removeUIState: removeUIState,
  loadCredentials: authActions.loadCredentials,
  clearFlashMessage: clearFlashMessage,
  loadNotificationCount: loadNotificationCount.request,
  deleteFavoriteMenu: authActions.deleteFavoriteMenu.request,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
